"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyContainer = exports.FlatList = exports.MainContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.MainContainer = native_1.default.SafeAreaView `
  border-radius: 5px;
  background-color: ${({ theme }) => theme.bpCore.colors.white};
  overflow: hidden;
  elevation: 5;
`;
exports.FlatList = native_1.default.FlatList `
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;
exports.EmptyContainer = native_1.default.View `
  padding-bottom: 24px;
`;
